import { __awaiter, __decorate, __generator } from "tslib";
import { singleton } from 'tsyringe';
import { getWebStoreApiClient } from '@gn-audio/core/auth';
var SFCCTokenService = /** @class */ (function () {
    function SFCCTokenService() {
    }
    Object.defineProperty(SFCCTokenService.prototype, "isAuthorized", {
        get: function () {
            return !!getWebStoreApiClient().account;
        },
        enumerable: false,
        configurable: true
    });
    SFCCTokenService.prototype.ensure = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getWebStoreApiClient().onTokenAcquired];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    SFCCTokenService = __decorate([
        singleton()
    ], SFCCTokenService);
    return SFCCTokenService;
}());
export { SFCCTokenService };
